/**
 * El buscador de ordenes.
 *
 * POR QUE ESTA ARRIBA DE TODO Y NO ADENTRO DE LA LISTA
 * ---------------------------------------------------
 * Entran de dos a cinco equipos por dia y llegan de cinco a quince consultas de
 * "¿esta listo el mio?". La pantalla se abre mucho mas veces para CONTESTAR por
 * un equipo que para cargar uno, casi siempre con alguien esperando del otro
 * lado del mostrador o del telefono. Entonces lo primero que se ve tiene que ser
 * el campo donde se tipea el apellido, no el tablero.
 *
 * Busca por cliente, numero de orden e IMEI —las tres formas en que alguien
 * nombra un equipo— y ademas por equipo y modelo, que es lo unico que se sabe
 * cuando el que llama no es el titular.
 */
import { InputBusqueda } from "@/components/ui/input-busqueda";

export interface BuscadorOrdenesProps {
  texto: string;
  onTexto: (t: string) => void;
  /** Cuantas ordenes quedaron a la vista y cuantas hay cargadas. */
  encontradas: number;
  total: number;
}

export function BuscadorOrdenes({
  texto,
  onTexto,
  encontradas,
  total,
}: BuscadorOrdenesProps): JSX.Element {
  const buscando = texto.trim().length > 0;

  return (
    <section className="space-y-2">
      <InputBusqueda
        valor={texto}
        onValorChange={onTexto}
        etiqueta="Buscar una orden de reparación"
        placeholder="Apellido, IMEI o N° de orden"
      />

      {buscando ? (
        <p className="text-xs text-muted-foreground">
          {encontradas} {encontradas === 1 ? "orden" : "órdenes"} de {total} cargadas
        </p>
      ) : null}
    </section>
  );
}
